import type { Client } from '@/types';

/**
 * Heading label that stays distinguishable when several markets share a display
 * name: the internal (legal) name is appended when it differs. The context-switcher
 * picker shows the same pair (display name over legal name), so closed switchers
 * and page headings must not collapse back to the display name alone.
 */
export function clientLabel(client: Pick<Client, 'display_name' | 'legal_name'>): string {
  if (client.legal_name && client.legal_name !== client.display_name) return `${client.display_name} (${client.legal_name})`;
  return client.display_name;
}
